// 固定フッターボタンがあれば、その高さに応じて body の下余白を調整するスクリプト
function applyFixedButtonSpacer() {
    const button = document.querySelector('.lpcb-fixed-button-front');
    if (!button) {
        document.body.style.paddingBottom = '';
        return;
    }

    // トップへボタンもあれば上に上げる
    const pageTop = document.querySelector('.c-page-top');
    const pageTopBottom = pageTop ? parseFloat(getComputedStyle(pageTop).bottom || '0') || 0 : 0;

    // ポップアップの右下設定もあれば上に上げる
    const popup = document.querySelector('.lpcb-pop-up-front.is-position-bottom-right');

    const updatePadding = () => {
        const height = button.offsetHeight;
        // console.log("height: " + height)
        document.body.style.paddingBottom = `${height}px`;
        if (pageTop) {
            pageTop.style.bottom = `${height + pageTopBottom}px`;
        }
        if ( popup ) {
           popup.style.bottom = `${height + pageTopBottom + 20}px`;
        }
    };

    updatePadding();

    const observer = new ResizeObserver(() => {
        updatePadding();
    });

    observer.observe(button);
    window.addEventListener('resize', updatePadding);
}
window.addEventListener('DOMContentLoaded', applyFixedButtonSpacer);

// スクロールしたら固定ボタンを表示するオプション
function toggleFixedButtonOnScroll({
    selector = '.lpcb-fixed-button-front.is-hidden-until-move',
    threshold = 300,
    duration = 500
} = {}) {
    const button = document.querySelector(selector);
    if (!button) return;

    // JSが制御を始めるときに display を有効化
    button.style.display = '';
    button.style.opacity = '0';
    button.style.pointerEvents = 'none';
    button.style.visibility = 'hidden';
    button.style.transition = `opacity ${duration}ms ease`;

    const updateVisibility = () => {
        const scrolled = window.scrollY;

        if (scrolled > threshold) {
            button.style.opacity = '1';
            button.style.pointerEvents = 'auto';
            button.style.visibility = 'visible';
        } else {
            button.style.opacity = '0';
            button.style.pointerEvents = 'none';
            button.style.visibility = 'hidden';
        }
    };

    updateVisibility();
    window.addEventListener('scroll', updateVisibility);
}

window.addEventListener('DOMContentLoaded', () => {
    toggleFixedButtonOnScroll();
});

